import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import { timeToMinutes } from "../../../../Utilitie";

const PDDSummaryGraph = ({ data, keyName }) => {
  const [chartData, setChartData] = useState(null);
  const [checkBox, setCheckBox] = useState(false);

  const getDaysInPeriod = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  const transformData = (data, checkBox, keyName) => {
    if (!data || !Array.isArray(data) || data.length < 1) {
      return {
        dimensions: ["product", "Previous", "Current"],
        series: [],
      };
    }

    const currentYearData = data[0] || {
      financial_year: "Current",
      children: [],
    };
    const previousYearData = data[1] || {
      financial_year: "Previous",
      children: [],
    };

    const currentYear = currentYearData.financial_year || "Current";
    const previousYear = previousYearData.financial_year || "Previous";

    const previousDays =
      previousYearData.start_date && previousYearData.end_date
        ? getDaysInPeriod(
            previousYearData.start_date,
            previousYearData.end_date,
          )
        : 365;
    const currentDays =
      currentYearData.start_date && currentYearData.end_date
        ? getDaysInPeriod(currentYearData.start_date, currentYearData.end_date)
        : 365;

    const stationMap = new Map();

    // Process previous year data
    previousYearData.children.forEach((station) => {
      const stationCode = station.station_code;
      const stationId = stationCode;
      let totalValue = 0;
      let monthCount = 0;

      station.children.forEach((month) => {
        month.data.forEach((item) => {
          if (item[keyName] !== undefined && item[keyName] !== null) {
            if (keyName === "avg_avg_time") {
              totalValue += timeToMinutes(item[keyName]);
            } else if (keyName === "total_total_time") {
              totalValue += parseFloat(item[keyName]) || 0; // Already in minutes
            } else {
              totalValue += parseInt(item[keyName]) || 0; // For total_trains_count
            }
            monthCount++;
          } else {
            console.warn(`Invalid ${keyName} for item:`, item);
          }
        });
      });

      const avgDailyValue =
        previousDays > 0 && monthCount > 0
          ? Math.round(totalValue / (checkBox ? monthCount * previousDays : 1))
          : 0;

      stationMap.set(stationId, {
        product: stationCode,
        [previousYear]: checkBox ? avgDailyValue : totalValue,
        [currentYear]: 0,
      });
    });

    // Process current year data
    currentYearData.children.forEach((station) => {
      const stationCode = station.station_code;
      const stationId = stationCode;
      let totalValue = 0;
      let monthCount = 0;

      station.children.forEach((month) => {
        month.data.forEach((item) => {
          if (item[keyName] !== undefined && item[keyName] !== null) {
            if (keyName === "avg_avg_time") {
              totalValue += timeToMinutes(item[keyName]);
            } else if (keyName === "total_total_time") {
              totalValue += parseFloat(item[keyName]) || 0; // Already in minutes
            } else {
              totalValue += parseInt(item[keyName]) || 0; // For total_trains_count
            }
            monthCount++;
          } else {
            console.warn(`Invalid ${keyName} for item:`, item);
          }
        });
      });

      const avgDailyValue =
        currentDays > 0 && monthCount > 0
          ? Math.round(totalValue / (checkBox ? monthCount * currentDays : 1))
          : 0;

      if (stationMap.has(stationId)) {
        stationMap.get(stationId)[currentYear] = checkBox
          ? avgDailyValue
          : totalValue;
      } else {
        stationMap.set(stationId, {
          product: stationCode,
          [previousYear]: 0,
          [currentYear]: checkBox ? avgDailyValue : totalValue,
        });
      }
    });

    const series = Array.from(stationMap.values()).sort(
      (a, b) => b[currentYear] - a[currentYear],
    );

    return {
      dimensions: ["product", previousYear, currentYear],
      series,
    };
  };

  useEffect(() => {
    if (data?.length > 0) {
      // Assuming keyName is an array with a single value
      const dataA = transformData(data, checkBox, keyName[0]);
      setChartData(dataA);
    } else {
      setChartData(null);
    }
  }, [data, keyName, checkBox]);
  return (
    <div className="newUiBody">
      {chartData && (
        <GroupedBarChart
          data={chartData}
          from={`PDD_${keyName.includes("total_trains_count") ? "C" : "T"}`}
          chartType="bar"
        />
      )}
      {chartData && (
        <div className="d-flex justify-content-between">
          {/* {buttons.map((name, index) => {
            return <div key></div>;
          })} */}
        </div>
      )}
    </div>
  );
};

export default PDDSummaryGraph;
